export const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost/hotel-api' 
  : 'https://dinespark.bitsparktechnologies.com/hotel-api'; // the backend folder on cPanel
